import React from "react";
import { Network } from "lucide-react";
import GlobalDetailDrawer from "modules/swiftboard/components/GlobalDetailDrawer";
import LifecycleBadge from "../../../components/LifecycleBadge";

function ItemList({ items, empty, render }) {
  if (!items?.length) return <span className="text-xs text-text_muted">{empty}</span>;
  return <ul className="divide-y divide-border rounded-lg border border-border">{items.map(render)}</ul>;
}

// Rules and templates built on a trigger. A rule activated on an older trigger version keeps it until re-activated.
export default function TriggerUsedByDrawer({ trigger, usedBy, onClose }) {
  const version = usedBy?.trigger_version_no ?? trigger.version_no;
  const sections = [
    {
      title: `Rules (${usedBy?.rules?.length ?? 0})`,
      fields: [
        {
          value: (
            <ItemList
              items={usedBy?.rules}
              empty="No rule uses this trigger yet."
              render={(rule) => (
                <li key={rule.id} className="flex items-center justify-between gap-3 px-3 py-2 text-xs">
                  <span className="min-w-0 truncate">
                    {rule.name} <span className="font-mono text-text_muted">{rule.code}</span>
                  </span>
                  <span className="flex shrink-0 items-center gap-2">
                    {rule.published_version_no > 0 && rule.published_version_no < version && <span className="text-[11px] text-warning">uses an older version</span>}
                    <LifecycleBadge status={rule.status} />
                  </span>
                </li>
              )}
            />
          ),
        },
      ],
    },
    {
      title: `Templates (${usedBy?.templates?.length ?? 0})`,
      fields: [
        {
          value: (
            <ItemList
              items={usedBy?.templates}
              empty="No template is written for this trigger."
              render={(template) => (
                <li key={template.id} className="flex items-center justify-between gap-3 px-3 py-2 text-xs">
                  <span className="min-w-0 truncate">
                    {template.name} <span className="font-mono text-text_muted">{template.code}</span>
                  </span>
                  <span className="shrink-0 text-[11px] text-text_muted">
                    {template.channel?.name ?? "—"} · v{template.version_no}
                  </span>
                </li>
              )}
            />
          ),
        },
      ],
    },
  ];
  return <GlobalDetailDrawer open onClose={onClose} title={`Used by · ${trigger.name}`} subtitle={`${trigger.code} · version ${version}`} icon={<Network size={20} />} sections={sections} />;
}
